<script setup lang="ts">
import {ConsumerReconciliation} from "@/core/interfaces/consumers/ConsumerReconciliation";
import formatHelper from "@/core/helpers/formatHelper";
import dateHelper from "@/core/helpers/dateHelper";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {Link, Unlink} from "@lucide/vue";
import {ref} from "vue";
import {reconciliationApi} from "@/container";

const props = defineProps<{
    reconciliation: ConsumerReconciliation
}>();

const emit = defineEmits(['hide']);

const loading = ref<'add' | 'reject' | 'remove' | null>(null);

/**
 * Delete the reconciliation.
 */
const cancel = async () => {
    await reconciliationApi().delete(props.reconciliation.id);

    emit('hide');
};
</script>

<template>
  <div class="flex border-b border-slate-50 py-4 hover:bg-gray-50">
    <div class="flex flex-1 flex-col gap-2">
      <div
        v-for="(reconciledKey, index) in reconciliation.keys" :key="index"
        class="flex text-sm items-center"
      >
        <div class="flex flex-1 items-center">
          <div v-if="reconciledKey.consumer" class="leading-3">
            <div class="flex items-center gap-1">
              <Link v-if="reconciledKey.validated_at" class="w-4 mb-1 ml-1 text-success" />
              <Unlink v-if="reconciledKey.rejected_at" class="w-4 mb-1 ml-1 text-red-400" />
              {{ formatHelper.patientName(reconciledKey.consumer) }},
              <span class="text-slate-500">
                né le {{ dateHelper.shortFormat(reconciledKey.consumer.birth_date) }}
              </span>
            </div>
            <div v-if="reconciledKey.consumer.customer" class="text-primary">
              ayant droit de <strong>{{ formatHelper.patientName(reconciledKey.consumer.customer) }}</strong>
              (N°SS {{ reconciledKey.consumer.customer.nir }})
            </div>
            <div v-else class="text-primary">
              assuré, <strong>N°SS {{ reconciledKey.consumer.nir }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col justify-center gap-4">
      <BaseButton density="compact" :loading="loading=='add'" @click="cancel">
        <Unlink class="w-4 mr-1" />
        Annuler tous les liens
      </BaseButton>
    </div>
  </div>
</template>

<style scoped>

</style>
